/**
 * The PDF's header (owner, 2026-10-16). The native pages hide their hero on paper, and the data-date pill sits in
 * the control band, which does not print either. So a printed page opens with this instead: the page (on
 * /channels, with its channel), then the workspace or "ทุก workspace" and the data date when it is known. Hidden on
 * screen.
 *
 * @module components/overview/PrintHeader
 */
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface PrintHeaderProps {
  /** The page's name; on /channels it also carries the channel ("Channel Deep-dive · Facebook"). */
  title: string;
  /** The workspace's name, or "ทุก workspace"; null or '' while unknown. */
  scope: string | null;
  /** The data date the pill shows (YYYY-MM-DD); null while unknown. */
  dataDate: string | null;
}

export const PrintHeader: React.FC<PrintHeaderProps> = ({ title, scope, dataDate }) => {
  const { t } = useTranslation();
  const line = [scope, dataDate ? t('looker.dataAsOf', { date: dataDate }) : null]
    .filter((part): part is string => Boolean(part))
    .join(' · ');
  return (
    <div data-print-header className="hidden print:block">
      <p className="text-base font-semibold text-ink-950">{title}</p>
      {line && <p className="text-xs text-neutral-800">{line}</p>}
    </div>
  );
};
